<template>
	<div v-lazyload>
		<img style="height:40px;width:40px" :data-url="src" />
	</div>
</template>
<script>

// https://public.boove.se/w2image/img130515_dl_832894829b30fdb995039a17bd7b74d2_img_130515_imp_917427c688.jpg

//import SelectManufactor from '@/components/product/search/SelectManufactor.vue';
//import { STORE_GETTER } from '@/store/store';

import LazyLoadDirective from "@/directives/LazyLoadDirective";
import settings from "../../settings";

export default {
	name: "ProductRowImage",
	components: {},
	mixins: [],
	props:{
		fileName: String
	},
	directives: {
		lazyload: LazyLoadDirective
	},
	data() {
		return {

		};
	},
	computed: {

		src(){
			return settings.baseImagePath + this.fileName;
		}
		


	},
	

	
};
</script>

<style scoped>


.loading img {
	opacity: 0.3;
}

.loaded img {
	opacity: 1;
	transition: opacity 0.3s ease;
}

</style>